import { render } from "./login-phone.vue?vue&type=template&id=7e6ff9d1&scoped=true&ts=true"
import script from "./login-phone.vue?vue&type=script&lang=ts"
export * from "./login-phone.vue?vue&type=script&lang=ts"

import "./login-phone.vue?vue&type=style&index=0&id=7e6ff9d1&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vue3-admin/vue3-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e6ff9d1"]])

export default __exports__